import { render, staticRenderFns } from "./TotalInforcedProposals.vue?vue&type=template&id=4cb2ddf8&scoped=true&"
import script from "./TotalInforcedProposals.vue?vue&type=script&lang=js&"
export * from "./TotalInforcedProposals.vue?vue&type=script&lang=js&"
import style0 from "./TotalInforcedProposals.vue?vue&type=style&index=0&id=4cb2ddf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2ddf8",
  null
  
)

component.options.__file = "TotalInforcedProposals.vue"
export default component.exports